package com.patronat.top.ui.atoms.inputs

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp

data class InputStyles(
    val borderColor: Color,
    val borderWidth: Dp,
    val backgroundColor: Color,
    val textColor: TextStyle,
    val placeholderColor: Color,
    val iconColor: Color
)